import { on } from 'delegated-events'

const header = document.querySelector('.site-header')

const state = {
  stuck: true,
}

const fn = {
  init: () => {
    fn.handleScroll()

    on('click', '.site-menu-btn', () => {
      document.documentElement.classList.toggle('js-nav-active')
    })

    window.addEventListener('scroll', fn.handleScroll)

    window.addEventListener('resize', () => {
      if (window.matchMedia('(min-width: 768px)').matches) {
        document.documentElement.classList.remove('js-nav-active')
      }
    })

    on('click', '.close-translate-bar', () => {
      const bar = document.querySelector('.translate-top-bar')

      if (bar) {
        bar.style.display = 'none'
      }
    })
  },

  handleScroll: () => {
    state.stuck = window.pageYOffset <= 0
    header.classList.toggle('is-stuck', state.stuck)
  },
}

export default {
  can: () => header,
  run: fn.init,
}
